// @flow

import _ from 'lodash';

import ApiObject from './ApiObject';

import Validation from '../utils/Validation';

export default class ClaimsDiscussionsSettings extends ApiObject {

  countdown: number = 0;

  /**
   * the number of stars maximum to send the mail.
   * @type {number}
   */
  maxRate: number = 1;

  enabled: boolean = false;

  emailSubject: string = '';

  senderName: string = '';

  senderEmail: string = '';

  emailBody: string = '';

  restaurantId: string = '';

  // -- setters

  /**
   * set the given coutdown as minutes to a timestamp
   * @param minutes
   */
  setCountdown(minutes: number) {
    this.countdown = minutes * 60 * 1000;
  }

  getCountdownAsMinutes(): number {
    return this.countdown / (60 * 1000);
  }


  // ---- Validation

  // TODO: validation

  /**
   * Verify that the object is correct
   */
  validate(): boolean {
    const errors = this.getValidationErrors();
    return errors.length === 0;
  }

  getValidationErrors(): Array<Object> {

    const validationErrorsInfo = [
      {
        key: 'countdown',
        error: 'Le temps est invalide',
        func: this.validateCountdown.bind(this)
      },
      {
        key: 'maxRate',
        error: '',
        func: this.validateMaxRate.bind(this)
      },
      {
        key: 'emailSubject',
        error: 'Le sujet est requis',
        func: this.validateSubject.bind(this)
      },
      {
        key: 'senderName',
        error: 'Le nom de l\'expediteur est requis',
        func: this.validateSenderName.bind(this)
      },
      {
        key: 'emailBody',
        error: 'Le contenu de l\'email est requis',
        func: this.validateContent.bind(this)
      },
      {
        key: 'senderEmail',
        error: 'Email invalide',
        func: this.validateSenderEmail.bind(this)
      }
    ];

    const errors = [];
    _.each(validationErrorsInfo, (validationInfo: Object) => {
      if (!validationInfo.func()) {
        errors[validationInfo.key] = validationInfo.error;
      }
    });

    return errors;
  }

  validateCountdown(): boolean {
    return _.isNumber(parseFloat(this.countdown)) && this.countdown > 0;
  }

  validateMaxRate(): boolean {
    return !_.isNull(this.maxRate) && this.maxRate >= 1 && this.maxRate <= 5;
  }

  validateSubject(): boolean {
    return !_.isEmpty(this.emailSubject);
  }

  validateSenderName(): boolean {
    return !_.isEmpty(this.senderName);
  }

  validateSenderEmail(): boolean {
    return !_.isEmpty(this.senderEmail) && Validation.email(this.senderEmail);
  }

  validateContent(): boolean {
    return !_.isEmpty(this.emailBody);
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/ClaimsDiscussionsSettings.js